<template>
  <div>
    <label class="fe-cursor-pointer">
      <JdsButton
        :full-width="true"
        variant="secondary"
        class-name="!fe-justify-center"
        @click="triggerFileInput"
      >
        <template #icon>
          <JdsIcon name="UploadIcon" size="m" color="fe-text-primary-60" />
        </template>
        <slot></slot>
      </JdsButton>
      <input
        v-if="isNetmedsNativeApp"
        ref="nativeInput"
        type="button"
        :key="fileInputKey"
        :title="inputTitle"
        class="fe-hidden"
        @click="handleSelectFile"
      />
      <input
        v-else
        ref="fileInput"
        type="file"
        :title="inputTitle"
        :multiple="allowMultipleImages"
        :accept="acceptFileType"
        class="fe-hidden"
        @change="handleFileUpload"
      />
    </label>
    <small v-if="helperText" class="fe-text-primary-grey-80 fe-text-body-xs">
      {{ helperText }}
    </small>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import {
    isAppVersionGreaterThanOrEqual,
    isMobileApp,
    sendToApp,
  } from "@/utils/utils"

  export default {
    components: {
      JdsButton,
      JdsIcon,
    },
    computed: {
      isNetmedsNativeApp() {
        if (isMobileApp() && localStorage.getItem("__application")) {
          return isAppVersionGreaterThanOrEqual()
        }

        return false
      },
    },
    props: {
      inputTitle: {
        type: String,
        default: "Upload files...",
        required: false,
      },
      helperText: {
        type: String,
        default: "",
        required: false,
      },
      allowMultipleImages: {
        type: Boolean,
        default: false,
        required: false,
      },
      acceptFileType: {
        type: [String, Array],
        default: "image/*",
        required: false,
      },
    },
    methods: {
      triggerFileInput() {
        if (this.isNetmedsNativeApp) {
          this.$refs.nativeInput.click()
        } else {
          this.$refs.fileInput.click()
        }
      },
      handleFileUpload(event) {
        const selectedFiles = event.target.files
        if (selectedFiles?.length) {
          this.$emit("selected", selectedFiles)

          // To remove the file metadata cache in browser, lets clear the file input
          this.$refs.fileInput.value = ""
        }
      },
      handleSelectFile() {
        sendToApp({ type: "gallery", params: {} })
      },
    },
  }
</script>
